export const SET_DRUG_DATA = "SET_DRUG_DATA";
export const CREATE_DRUG_DATA = "CREATE_DRUG_DATA";
export const DISABLE_LOADING = "DISABLE_LOADING";
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export const SET_SORTING = "SET_SORTING";
export const SET_FILTERS = "SET_FILTERS";
export const SET_TOTAL_COUNT = "SET_TOTAL_COUNT"
export const DELETE_DRUG_DATA = "DELETE_DRUG_DATA"